import React from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentType } from '../../../Data/PaymentTypeEnum.ts';
import '../OrderIndex.css'

const PaymentCard = ({ order }) => {

  const { t } = useTranslation();

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='justify-content-center mt-2'>
          <div>
            <div className='panel-header-title'>{t('payment')}</div>
            <div className="order-checkbox-option">
              <div className="option">
                <input className='checkbox-custom' type='checkbox' checked={true} />
                <label>{order.payment} </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentCard